import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
// import * as notifyManager from '../utils/notifyManagement';
import { defaultQueryProps } from '../utils/fetch-utils';

export const Context = React.createContext();

const ContextProvider = ({ children }) => {
  const value = useMemo(() => ({
    clientIp: '127.0.0.1',
    // notifyManager,
    defaultQueryProps,
  }), []);

  const visibleChildren = children;

  return (
    <Context.Provider value={value}>
      {visibleChildren}
    </Context.Provider>
  );
};

ContextProvider.defaultProps = {
  additionalContext: {},
};

ContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  additionalContext: PropTypes.shape({}),
};

export default ContextProvider;
